import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SetupItems } from '../models/setupItems';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { SelectItem } from 'primeng/api';
import { SaveTemplates, Templates } from '../models/emailevents.model';

@Injectable({
  providedIn: 'root'
})
export class EmailEventsService extends ServiceBase {
  private api: string = '/EmailTemplates';

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getSystemEmailEvents(): Observable<SelectItem[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SelectItem[]>(url, httpOptions);
  }



  public fetchallevents(): Observable<Event[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch-all-events';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Event[]>(url, httpOptions);
  }

  public fetchAllTemplates(): Observable<Templates[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch-templates';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<Templates[]>(url, httpOptions);
  }

  public getEmailTemplateParameters(emailTemplateId: string): Observable<SelectItem[]> {
    var httpOptions = this.RequestHeaders();

    var method: string = '/fetchEmailParameters';
    if (emailTemplateId) {
      method += '/' + emailTemplateId;
    }
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SelectItem[]>(url, httpOptions);
  }


  public getEmailTemplate(id: string): Observable<SaveTemplates> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/fetch-template/${id}`;
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SaveTemplates>(url, httpOptions);
  }

  public getEmailParameterById(parameterId: string): Observable<EmailParameterResponse> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch-parameter-data';
    var url: string = environment.BASE_API_PATH + this.api + method + '/' + parameterId;
    return this.http.get<EmailParameterResponse>(url, httpOptions);
  }


  public saveEmailEvents(emailEvents: SaveTemplates): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/save-update';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, emailEvents, httpOptions);
  }

  public saveEmailParameterField(emailParameterData: EmailParameterResponse): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/save-parameter-field';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, emailParameterData, httpOptions);
  }

  public sendTestEmail(sendEmailEventData: SendEmailEventData): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/sendTestEmail';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, sendEmailEventData, httpOptions);
  }

  public deleteEmailTemplate(templateId: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = `/delete-email-template/${templateId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

}

export interface Event {
  EventName: string;
  EventId: string;
  EventDescription: string;
  HtmlText?: string | null;
  Subject: string;
  CreatedDate?: string | null;
  ModifiedDate?: string | null;
}

export class EmailEvent {
  Guid!: string;
  HtmlText!: string;
  EventId!: string;
  Subject!: string;
}

export class SendEmailEventData {

  HtmlContent!: string;
  SendTo!: string;
  Subject!: string;
}

export class EmailParameterResponse {
  Guid!: string;
  ParameterName!: string;
  ParameterDescription!: string;
  ParameterUsage!: string;
}
export class SmsParameterResponse {
  Guid!: string;
  ParameterName!: string;
  ParameterDescription!: string;
  ParameterUsage!: string;
}